import {Controller} from '@stubhub/react-store-provider';

import {urgencyMessagingSelector} from './selectors';

const NAMESPACE = 'urgencyRewording';

const controller = new Controller({
  namespace: NAMESPACE,
  mapStateToProps(state) {
    const showUrgencyRewording = urgencyMessagingSelector(state);

    return {
      showUrgencyRewording,
    };
  },
});

export default controller;
